module.exports = __webpack_public_path__ + "static/dining2-e8cf465576d26b254dcbbf948ab34f1e.jpg";